var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 78",
    style: {
      enableBackground: "new 0 0 86 78"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;opacity:0.2;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:#000000;}\r\n\t.st6{fill:#000000;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st8{fill:#000000;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st9{display:inline;}\r\n\t.st10{fill:none;stroke:#C9C9C9;stroke-width:0.1;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#C9C9C9;stroke-width:0.071;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#C9C9C9;stroke-width:0.0707;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Base_tile"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 43,
    cy: 39,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.0042,29.64V38h-8.36C34.1042,33.6,37.6042,30.1,42.0042,29.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.3542,38h-8.35v-8.36C48.4042,30.1,51.8942,33.6,52.3542,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.6442,40h8.36v8.36C37.6042,47.9,34.1042,44.4,33.6442,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.3542,40c-0.46,4.4-3.95,7.9-8.35,8.36V40H52.3542z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Guide2",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomControl);
export default __webpack_public_path__ + "static/media/CustomControl.6e39666adc7adba8fe5de4f6d51ae01a.svg";
export { ForwardRef as ReactComponent };